import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpVideo, VideosHttpResult } from '../../models/video.model';

export const FavoritesAction = createActionGroup({
  source: 'Favorites',
  events: {
    'Get Favorites': props<{start: number, count: number, forceReload?: boolean}>(),
    'Favorites Loaded': props<{payload: VideosHttpResult, reset?: boolean, page: number, pageSize: number}>(),
    'Load From Start': props<{count: number, reset?: boolean}>(),
    Load: emptyProps(),
    'Already Loaded': emptyProps(),
  }
});
